<template>
  <div v-bind:style="{fontFamily:this.template_configuration.selected_font+', sans-serif !important'}">
    <!--Footer conditional section -->
    <footer-one v-if="this.template_configuration.footer_style == 1" :settings_style="this.template_configuration" :quote_data="quote_data"></footer-one>
    <footer-two v-if="this.template_configuration.footer_style == 2" :settings_style="this.template_configuration" :quote_data="quote_data"></footer-two>
    <footer-three v-if="this.template_configuration.footer_style == 3" :settings_style="this.template_configuration" :quote_data="quote_data"></footer-three>
    <footer-four v-if="this.template_configuration.footer_style == 4" :settings_style="this.template_configuration" :quote_data="quote_data"></footer-four>
  </div>
  
</template>
<script>

/* Import of Footer */
import footerOne from "@/components/pdf/footer/footerOne";
import footerTwo from "@/components/pdf/footer/footerTwo";
import footerThree from "@/components/pdf/footer/footerThree";
import footerFour from "@/components/pdf/footer/footerFour";

export default {
  mounted(){
  },
  components:{
    footerOne,
    footerTwo,
    footerThree,
    footerFour,
  },
  props: {
    template_configuration: {
      required: true,
    },
    quote_data:{
      type:Object
    }
  },
  methods:{
    
  }
};
</script>